<template>
  <div class="tradeOrder">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="container">
          <div class="list-item">
            {{ $t.tradeOrder.jobNumber }}：{{ item.WorkOrderNumber }}
          </div>
          <div class="list-item">
            {{ $t.tradeOrder.orderNumber }}：{{ item.PurchaseOrderCode }}
          </div>
          <div class="list-item">
            {{ $t.tradeOrder.customerNumber }}：{{ item.CustomerNumber }}
          </div>
          <div class="list-item">
            {{ $t.tradeOrder.customerCompanyName }}：{{ item.CompanyName }}
          </div>
          <div class="list-item">{{ $t.tradeOrder.tradeTerms }}：{{ item.TCName }}</div>
          <div class="list-item">
            {{ $t.tradeOrder.deliveryDestination }}：{{ item.DeliveryDestination }}
          </div>
          <div class="list-item">
            {{ $t.tradeOrder.totalReceive }}：{{ item.OrderReceivableTotalAmount }}
          </div>
          <div class="list-item">
            {{ $t.tradeOrder.receivable }}：{{ item.ReceivableBalance }}
          </div>
          <div class="list-item">
            {{ $t.tradeOrder.taxRefundTotalAmount }}：{{ item.TaxRefundTotalAmount }}
          </div>
          <div class="list-item">
            {{ $t.tradeOrder.procurementTotalAmount }}：{{ item.ProcurementTotalAmount }}
          </div>
          <div class="list-item">
            {{ $t.tradeOrder.paymentBalance }}：{{ item.PaymentBalance }}
          </div>
          <div class="buttons">
            <van-button
              class="default-btn"
              size="small"
              type="primary"
              @click="dialogPrintShow(item.TOId)"
              >{{ $t.meta.print }}</van-button
            >

            <van-button
              class="search-btn"
              size="small"
              type="primary"
              @click="gotoReconciliation(item.TOId)"
              >{{ $t.tradeOrder.reconciliation }}</van-button
            >

            <van-button
              class="primary-btn"
              size="small"
              type="primary"
              @click="gotoTradeOrderCreate(item.TOId)"
              >{{ $t.meta.editButton }}</van-button
            >

            <van-button
              class="danger-btn"
              size="small"
              type="primary"
              @click="dialogDeleteShow(item.TOId)"
              >{{ $t.meta.delete }}</van-button
            >
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-dialog
      :title="$t.tradeOrder.printTitle"
      width="80%"
      v-model="showPrintDialog"
      @confirm="printConfirm"
      @cancel="printCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="tradeOrder-alert">
          <van-radio-group v-model="dialogPrintType">
            <van-radio :name="1">{{ $t.tradeOrder.printOption1 }}</van-radio>
            <van-radio :name="2">{{ $t.tradeOrder.printOption2 }}</van-radio>
          </van-radio-group>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteTradeOrder"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoTradeOrderCreate(null)">{{
        $t.tradeOrder.createOrder
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "tradeOrder",
  data() {
    return {
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.tradeOrder.jobNumber,
          value: 1,
        },
        {
          text: this.$t.tradeOrder.orderNumber,
          value: 2,
        },
        {
          text: this.$t.tradeOrder.customerNumber,
          value: 3,
        },
        {
          text: this.$t.tradeOrder.customerCompanyName,
          value: 4,
        },
      ],
      showFilter: false,
      //删除订单
      showDeleteDialog: false,
      dialogDeleteId: null,
      //打印
      showPrintDialog: false,
      dialogPrintId: null,
      dialogPrintType: 1,
    };
  },
  created() {},
  methods: {
    printConfirm() {
      var param = {
        TOId: this.dialogPrintId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value:
              this.dialogPrintType == 1
                ? "createProcurementProductListFile"
                : "createSalesTradeOrderFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    printCancel() {
      this.dialogPrintId = null;
      this.showPrintDialog = false;
    },
    dialogPrintShow(id) {
      this.dialogPrintId = id;
      this.showPrintDialog = true;
    },
    gotoTradeOrderCreate(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "tradeOrderCreate",
        name: "tradeOrderCreate",
        query: [
          {
            name: "TOId",
            value: id ? id : null,
          },
        ],
      });
    },
    gotoReconciliation(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "tradeOrderReconciliation",
        name: "tradeOrderReconciliation",
        query: [
          {
            name: "TOId",
            value: id ? id : null,
          },
        ],
      });
    },
    deleteTradeOrder() {
      this.$commonMethod.showLoading();
      var param = {
        TOId: this.dialogDeleteId,
      };
      this.$api.purchasingManagement
        .deleteTradeOrder(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.showDeleteDialog = false;
          this.tableData = [];
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      return false;
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        WorkOrderNumber: this.searchType == 1 ? this.searchText : "",
        PurchaseOrderCode: this.searchType == 2 ? this.searchText : "",
        CustomerNumber: this.searchType == 3 ? this.searchText : "",
        CustomerName: this.searchType == 4 ? this.searchText : "",
      };
      this.$api.purchasingManagement
        .getTradeOrderListByPage(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.tradeOrder {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tradeOrder-alert {
    overflow: scroll;
    margin: 26px 16px 0px 0px;
    text-align: center;
    .van-radio-group {
      display: inline-block;
      margin: 0;
      .van-radio {
        margin-bottom: 26px;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
